import React from 'react'
import { Row, Col } from "react-bootstrap"
import PropTypes from 'prop-types';
import { IconButton } from '@fluentui/react';
import { useTranslation } from 'react-i18next';

function PartyAgrupationItem(props) {
    const { t } = useTranslation();

    const {
        inputParam_ElementIndex = null,
        inputParam_ElementItem = null,
        inputParam_NormalizedPosition = null,
        inputParam_SetPartyGroupToEdit = null,
        inputParam_DeletePartyGroup = null,
        inputParam_EditMode = null,
    } = props;

    const onEditPartyAgrupation = () => {
        inputParam_SetPartyGroupToEdit( {id: inputParam_ElementItem.id, name: inputParam_ElementItem.title, position: inputParam_ElementItem.posicion} )
    }

    const onDeletePartyAgrupation = () => {
        inputParam_DeletePartyGroup(inputParam_ElementItem.id)
    }

    return (
        <>
            <Row className={`py-1 ${inputParam_ElementIndex !== null && inputParam_ElementIndex !== 0 ? 'border-top' : ''}`} style={{borderBottom: "2px solid #c8c3c3 !important"}}>
                <Col className='col-auto ms-auto my-auto' style={{ backgroundColor: '#11447f', color: 'white', fontWeight: 'bold' }}>
                { inputParam_NormalizedPosition }
                </Col>
                <Col className='my-auto'>
                { inputParam_ElementItem.title }
                </Col>
                <Col className='my-auto'>
                { inputParam_ElementItem.vigente ? t('data-lang-lbl-inforce') : t('data-lang-lbl-notinforce') }
                </Col>
                {
                    inputParam_EditMode &&
                    <Col className='col-auto me-auto d-flex my-auto'>
                        <IconButton iconProps={{iconName: "Edit"}} onClick={onEditPartyAgrupation} />
                        <IconButton iconProps={{iconName: "Delete"}} onClick={onDeletePartyAgrupation} />
                    </Col>
                }
            </Row>
        </>
    );
}

PartyAgrupationItem.propTypes = {
    inputParam_ElementItem: PropTypes.object.isRequired,
};

export default PartyAgrupationItem;